<template>
  <div v-if="!loading">
    <v-container>
      <v-form ref="form">
        <v-row>
          <v-col>
            <h2 class="pb-5">{{ this.pageTitle }}</h2>
          </v-col>
        </v-row>

        <v-container
          id="scroll-target"
          class="custom-form px-5"
          style="max-height: none;"
        >
        <v-row>
          <v-col cols="12" sm="6" class="pb-n5 pt-2">
            <v-autocomplete
              outlined
              :label="this.$t('alleissocso.socsoandeissubmissionrec')"
              type="text"
              v-model="formData.eissocsoexprecid"
              :items="eissocsoExpRecList"
              :rules="[rules.required]"
              @change="changeSocsoExportRecord(formData.eissocsoexprecid)"
              dense
            ></v-autocomplete>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" sm="3" class="mb-n1 mt-n8">
            <v-text-field
              outlined
              :label="this.$t('statutoryexportcommonused.payoutyear')"
              type="text"
              v-model="formData.year"
              readonly
              dense
              background-color="#ffeab2"
            ></v-text-field>
          </v-col>

          <v-col cols="12" sm="3" class="mb-n5 mt-n8">
            <v-text-field
              outlined
              :label="this.$t('bankpaymentlistingreport.payoutmonth')"
              type="text"
              v-model="formData.month"
              readonly
              dense
              background-color="#ffeab2"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="6" sm="6" class="blue--text ml-2"> {{$t('statutoryexportcommonused.payouts')}} </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" sm="12">
            <v-data-table
              :headers="dataHeader"
              :items="this.payoutItems"
              :options="tableOpt"
              hide-default-footer
              item-key="payoutcode"
            >
            </v-data-table>
          </v-col>
        </v-row>

        <!-- <v-row>
          <v-col cols="12" sm="6" class="pb-n5 mt-3">
            <v-text-field
              outlined
              :label="Reference No."
              type="text"
              v-model="formData.refnum"
              readonly
              dense
              background-color="#ffeab2"
            ></v-text-field>
          </v-col>
        </v-row> -->

        
          <v-row>
            <v-col cols="12" sm="6" class="pb-n5 mt-3">
              <v-autocomplete
                outlined
                :label="this.$t('recfamdetails.refno')"
                type="text"
                v-model="formData.eisrefnum"
                :rules="[rules.required]"
                :items="eissocsoSubRefRecList"
                dense            
              ></v-autocomplete>
            </v-col>
          </v-row>

        <v-row>
          <v-col cols="12" sm="6" class="pb-n5 mt-n8">
            <v-autocomplete
              outlined
              v-model="formData.eissocsoexpformatid"
              :label="this.$t('alleissocso.socsoandeisexportformat')"
              type="text"
              :items="this.exportFmtList"
              :rules="[rules.required]"
              dense
            ></v-autocomplete>
          </v-col>
        </v-row>
        </v-container>

        <v-row>
          <div class="pt-5 pl-4 pb-4">
            <v-btn color="warning" style="width: 100px; margin-bottom: 20px;" @click="nextHandler">
              {{$t('button.next')}}
            </v-btn>
          </div>
        </v-row>
      </v-form>
    </v-container>
    <div v-if="isErr">
      <app-error
        v-bind:parentError="{
          data: this.errMsg,
          isErr: this.isErr,
        }"
        v-on:closeError="isErr = $event"
      />
    </div>
  </div>
</template>

<script>

import ErrorDialog from "../../../components/common/ErrorDialog";

export default {
  components: {
    "app-error": ErrorDialog,
  },

  data() {
    return {
      rules: {
        required: (value) => !!value || this.$t('reportsparam.required'),
        email: (value) => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || this.$t('reportsparam.invalidemail');
        },
      },
      pageTitle: this.$t('alleissocso.socsoandeisexportprocess'),
      dataHeader: [
        { text: this.$t('reportsparam.payout'), value: "payoutcode", width: "150px", sortable: true },
        {
          text: this.$t('payrollenquiryreport.payoutdesription'),
          value: "payoutdesc",
          width: "300px",
          sortable: true,
        },
        {
          text: this.$t('payrollprocessrun.payoutstatus'),
          value: "pystatusdesc",
          width: "300px",
          sortable: true,
        },
      ],
      formData: {
        eissocsoexprecid: null,
        eisrefnum: null,
        year: null,
        month: null,
        myntlycode: null,
        eissocsosubrecpy: [],
        eissocsosubrecref: [],
        eissocsoexpformatid: null,
      },

      tableOpt: {
        itemsPerPage: -1,
      },

      items: [],
      dataItems: [],
      salaryExpRecList: [],
      eissocsoExpRecList: [],
      payoutItems: [],
      exportformatItems: [],
      exportFmtList: [],
      eissocsoSubRefRecList: [],
      data2: [],
      notFinalize: false,
      loading: false,
      isErr: false,
      errMsg: "",
    };
  },

  methods: {
    getSocsoSubRecs() {
      const vm = this;

      this.loading = !this.loading;

      this.$store.dispatch('get', {url: "/eissocsosubmissionrecord/all"})
        .then(function (res) {
          vm.dataItems = res.data.rec;

          for (let i = 0; i < res.data.rec.length; i++) {
            vm.eissocsoExpRecList.push({
              text: res.data.rec[i].eissocsubreccode,
              value: res.data.rec[i].id,
            });
          }
         
          vm.loading = !vm.loading;
 

        })
        .catch(function (err) {
          vm.errMsg = err;
        });
    },

    getSocsoSubRecPayout(id) {
      const vm = this;

      this.loading = !this.loading;

      this.$store.dispatch('get', {url: "/eissocsosubmissionrecordpy/" + id})
        .then((res) => {
          vm.payoutItems = res.data.rec;
          vm.formData.eissocsosubrecpy = vm.payoutItems;

          for (let i = 0; i < vm.payoutItems.length; i++) {
            if (vm.payoutItems[i].pystatuscode != 99) {
              this.notFinalize = false;
            } else {
              this.notFinalize = true;
            }

            vm.data2.push(this.notFinalize)
            
          }

          vm.loading = !vm.loading;
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
    },

    getSocsoSubRecRef(id) {
      const vm = this;

      this.loading = !this.loading;

      this.$store.dispatch('get', {url: "/eissocsosubmissionrecordref/" + id})
        .then((res) => {
          vm.formData.eissocsosubrecref = res.data.rec;

          // vm.socsosubrefnum = res.data.rec.socsorefnum
          // vm.eissubrefnum = res.data.rec.eisrefnum

          // console.log('123', vm.socsosubrefnum)
          //set the socsoSubRefRecList array null (to avoid getting value from previous array)

          vm.eissocsoSubRefRecList = [];
          
          for (let i = 0; i < res.data.rec.length; i++) {
          if(res.data.rec[i].socsorefnum === res.data.rec[i].eisrefnum ){
            vm.eissocsoSubRefRecList.push({
              text: res.data.rec[i].socsorefcode + ' - ' + res.data.rec[i].socsorefnum + ' & ' + res.data.rec[i].eisrefcode + ' - ' + res.data.rec[i].eisrefnum ,
              value: res.data.rec[i].eisrefnum,
            });
          }
          }

          vm.loading = !vm.loading;
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
    },

    getExportFormattListHandler() {
      const vm = this;

      this.$store.dispatch('get', {url: "/exportformat/all"})
        .then(function (res) {
          vm.exportformatItems = res.data.rec;
          console.log('export', vm.exportformatItems)

          for (let i = 0; i < res.data.rec.length; i++) {
            if (res.data.rec[i].exptypeid == 8) {
              vm.exportFmtList.push({
                text: res.data.rec[i].expdesc,
                value: res.data.rec[i].id,
              });
            }
          }
        })
        .catch(function (err) {
          vm.errMsg = err;
        });
    },

    changeSocsoExportRecord(id) {
      let itemExportRecord = this.dataItems.find((item) => item.id === id);

      this.formData.eissocsoexprecid = itemExportRecord.id;
      this.formData.year = itemExportRecord.recyear;
      this.formData.month = itemExportRecord.recmonth;
      this.formData.myntlycode = itemExportRecord.myntlycode;

      this.getSocsoSubRecPayout(id);
      this.getSocsoSubRecRef(id);
    },

    nextHandler() {
      let item = this.formData;

      let id = this.formData.eissocsoexpformatid;

      var newvalue = true;
    
      for (let i = 0; i < this.data2.length; i++) {
         
        if (!this.data2[i])
        {
          newvalue = false;
        }
      }
      
      if (newvalue == false) {
        this.isErr = true;
        this.errMsg =
        this.$t('vdatatable.payoutnotfinalized');
      } else {
        if (this.$refs.form.validate()) {
          this.$router.push({
            name: "monthlyeissocsoexportparam",
            params: { id, item },
          });
        } else {
          this.isErr = true;
          this.errMsg = this.$t('vdatatable.someinfoismissing');
        }
    
      }
    },
  },

  mounted() {
    this.getSocsoSubRecs();
    this.getExportFormattListHandler();
  },
};
</script>

<style scoped>
</style>